import { render, staticRenderFns } from "./ReStaffNotificationList.vue?vue&type=template&id=fe456116&scoped=true"
import script from "./ReStaffNotificationList.vue?vue&type=script&lang=js"
export * from "./ReStaffNotificationList.vue?vue&type=script&lang=js"
import style0 from "./ReStaffNotificationList.vue?vue&type=style&index=0&id=fe456116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe456116",
  null
  
)

export default component.exports